import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueMessages from "vue-messages";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "wowjs/css/libs/animate.css";
import BMap from "vue-baidu-map";
import echarts from "echarts";
import Banners from "@/components/banner/Banners.vue";
import Title from "@/components/Title.vue";
import Search from "@/components/search/index.vue";
import HeaderIcon from "@/components/user/headerIcon.vue";
import UserTitle from "@/components/user/title.vue";
import Input from "@/components/user/input.vue";
import Industry from "@/components/industry.vue";
import AreaInput from "@/components/area/index.vue";
import FormContext from "@/components/user/formContext.vue";
import moment from "moment"; //导入模块
import "moment/locale/zh-cn";
moment.locale("zh-cn"); //设置语言 或 moment.lang('zh-cn');
Vue.prototype.$moment = moment; //赋值使用

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.use(BootstrapVue);
Vue.use(Antd);
Vue.use(IconsPlugin);
Vue.use(BMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: "nSxiPohfziUaCuONe4ViUP2N"
});
Vue.use(VueMessages, {
  content: "",
  duration: 2, // unit: s
  styles: {
    top: 36, // unit: px
    fontWeight: "normal", // normal or bold
    fontSize: "14px",
    position: "fixed",
    padding: "10px",
    lineHeight: "21px"
  }
});

//component
Vue.component("FormContext", FormContext);
Vue.component("Banners", Banners);
Vue.component("Title", Title);
Vue.component("Search", Search);
Vue.component("HeaderIcon", HeaderIcon);
Vue.component("UserTitle", UserTitle);
Vue.component("UserInput", Input);
Vue.component("AreaInput", AreaInput);
Vue.component("Industry", Industry);

new Vue({
  router,
  BootstrapVue,
  IconsPlugin,
  render: h => h(App)
}).$mount("#app");
